// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__kcr3m","menu__list":"Menu_menu__list__mwqjw"};